import { render } from "./IndexIntervention.vue?vue&type=template&id=f9785c98"
import script from "./IndexIntervention.vue?vue&type=script&lang=js"
export * from "./IndexIntervention.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__